
$controllers.mailboxsettings = {

	handleConnectResponse: function($response) {
		console.log($response);
		// hide all existing connection status messages and show relevant one
		jQuery('.connection-status').hide();
		jQuery('.connection-status#connected').show();
		jQuery('#button-wait').hide();

		// success!  we are connected, and data has already been saved to user profile, so show a notification
		$models.login.setCachedDetails($response.user);

		// When returning after connecting via OAuth we need to set the
		// `remote_email` because it was not input into our UI by the user (it
		// gets captured in the OAuth flow).
		jQuery('#remote_email').val($response.user.remote_username)

		// set the values of each of the form fields based on the existing profile data
		jQuery.each($response.user, function($key, $value) {
			if ($value === false) { $value = 'false'; }
			if ($value === true) { $value = 'true'; }
			if (($value != null) && ($value !== '')) {
				jQuery('#profile-form #'+$key).val($value);
			}
		});

		$soupmail.notification.message('Your Soup Mail account is now connected to your mailbox.');
		jQuery('#user-profile-sync-settings').show();
		$views.mailboxsettings.showSyncFormReadOnly();

		// if help is open tick connect mailbox
		if (jQuery('#help').css('display') == 'block') {
			jQuery('#help .connect-mailbox').addClass('done');
		}
	},

	display : function($fromHelp) {

		if (!$controllers.all.enforcePagePermissions('mailboxsettings')) { return false; }
		$controllers.all.showPage('mailboxsettings', 'contentpage');
		$controllers.all.setNavigation();
		$views.mailboxsettings.display($fromHelp);

		jQuery('#button-edit').click(function(e) {
			e.preventDefault();
			$views.mailboxsettings.showSyncFormBasic();
			jQuery('#edit-cancel').show();
		});

		jQuery('#button-save').click(function(e) {
			e.preventDefault();
			$controllers.mailboxsettings.save();
		});
	},

	displayFromHelp : function() {

		$controllers.mailboxsettings.display(true);
		$controllers.all.help(true);

	},

	autoDiscoverConnectionSettings : function() {

		// quick validation
		if (jQuery('#advanced').css('display') == 'none') {

			// validate email address (if Basic mode was chosen)
			var $email = jQuery.trim(jQuery('#remote_email').val());
			if (!$email || $email == 'Enter an email address') {
				$soupmail.modal.error('Please enter an email address');
				return false;
			}
			var validator = new $soupmail.validator();
			if (!validator.validateEmail($email)) {
				$soupmail.modal.error('Please enter a valid email address');
				return false;
			}

		} else {

			// validate port number (if Advanced mode was chosen)
			if (jQuery('#port').val() && !$soupmail.string.isPositiveInteger(jQuery('#port').val())) {
				$soupmail.modal.error('Please enter a port number between 1 and 99999');
				return false;
			}
			// validate IMAP mailbox prefix (if Advanced mode was chosen)
			if (jQuery('#imap_prefix').val() && (jQuery('#imap_prefix').val().indexOf('.') < 0)) {
				$soupmail.modal.error('IMAP prefix, if specified, must contain a full stop.  For example "INBOX." is valid whereas "INBOX" is not.');
				return false;
			}

		}
		// validate remote mailbox password
        if (!jQuery('#remote_password').val() && !jQuery('#ui_remote_access_type').val()) {
			$soupmail.modal.error('Please enter your email password');
			return false;
		}

		// init form data object
		var $formData = {};

		// get Basic or Advanced fields as necessary
		if (jQuery('#advanced').css('display') == 'none') {
			$formData.mailbox_type = jQuery('#ui_remote_access_type').val();
			$formData.remote_email = $email;
			$formData.remote_password = jQuery('#remote_password').val();
		} else {
			$formData.mailbox_type = jQuery('#ui_remote_access_type').val();
			$formData.remote_username = jQuery('#remote_username').val();
			$formData.remote_password = jQuery('#remote_password').val();
			$formData.host = jQuery('#host').val();
			$formData.port = jQuery('#port').val();
			$formData.ssl = jQuery('#ssl').val();
			if (jQuery('#ui_remote_access_type').val() == 'exchange') {
				$formData.ews_path = jQuery('#ews_path').val();
			} else if ((jQuery('#ui_remote_access_type').val() == 'imap') && jQuery('#imap_prefix').val()) {
				$formData.imap_prefix = jQuery('#imap_prefix').val();
			}
		}

		// hide all existing connection status messages and show relevant one
		jQuery('.connection-status').hide();
		jQuery('.connection-status#connecting').show();
		jQuery('#button-connect').hide();
		jQuery('#edit-cancel').hide();
		jQuery('#button-wait').show();

		// lookup sync connection details via the API
		$models.sync.getConnectionDetails($formData, $controllers.mailboxsettings.handleConnectResponse, function($response) {

			// hide all existing connection status messages and show relevant one
			jQuery('.connection-status').hide();
			jQuery('.connection-status#connection-failed').show();
			jQuery('#button-wait').hide();

			// failure, could not connect... handle this scenario differently based on the error_category
			if ($response.error_category == 'authentication') {

				// authentication error: wrong username or password
				$soupmail.notification.error('Connection failed: invalid username or password specified.  Please re-enter your password and double check your email address/username.');
				jQuery('#user-profile-sync-basic, #mailbox_selector, #button-connect').show();
				$views.mailboxsettings.showSyncFormAdvanced(1500);
				jQuery('#user-profile-sync-settings').hide();

			} else {

				// failure for other reasons... show the user the form in Advanced mode, but without Sync Settings
				$views.mailboxsettings.showSyncFormAdvanced(1500);
				$soupmail.notification.error('Connection failed, please enter advanced settings');
				jQuery('#user-profile-sync-settings').hide();

			}

			// if help is open untick connect mailbox
			if (jQuery('#help').css('display') == 'block') {
				jQuery('#help .create-mailbox').removeClass('done');
			}

			// save sync disabled
			$controllers.mailboxsettings.disableSync();

		});

	},

	enableSync : function() {

		var $formData = { user: {} };
		$formData.user.sync_enabled = true;

		// save changes
		$models.users.setMyData($formData, function() { });

	},

	disableSync : function() {

		var $formData = { user: {} };
		$formData.user.sync_enabled = false;

		// save changes
		$models.users.setMyData($formData, function() { });

	},

	save : function() {

		// quick validation
		if (!jQuery('#sync_window_days').val()) {
			$soupmail.notification.error('Please ensure all fields are filled in');
			return false;
		}
		if (isNaN(jQuery('#sync_window_days').val()) || (parseInt(jQuery('#sync_window_days').val()) < 1) || (parseInt(jQuery('#sync_window_days').val()) > 99)) {
			$soupmail.notification.error('The setting for number of days to sync must be a number between 1 and 99');
			return false;
		}

		// get data from form
		var $formData = { user: {} };
		$formData.user.sync_window_days = jQuery('#sync_window_days').val();
		$formData.user.sync_which_folders = jQuery('#sync_which_folders').val();

		// save changes
		$models.users.setMyData($formData, function() {
			$soupmail.notification.message('User profile changes have been saved successfully');
		});

	}

};



// WEBPACK FOOTER //
// ./src/js/controllers/desktop.mailboxsettings.js